import Link from "next/link";
import { ReactNode } from "react";
import { ExternalLink } from "ui/components";

interface FooterLinkProps {
  children: ReactNode;
  href: string;
  external?: boolean;
}

export function FooterLink({ children, href, external = false }: FooterLinkProps) {
  const className = "text-white hover:opacity-70 transition-opacity text-[14px] md:text-[16px] font-light";

  if (external) {
    return (
      <ExternalLink href={href} className={className}>
        {children}
      </ExternalLink>
    );
  }

  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
